import { Link } from "react-router-dom";
import "./SiteFooter.css";

const FOOTER_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/pricing", label: "Pricing" },
  { to: "/login", label: "Login" },
];

const SiteFooter = () => (
  <footer className="site-footer">
    <div className="site-footer__inner">
      <div className="site-footer__brand">
        <div className="site-footer__logo-row">
          <span className="site-footer__logo" aria-hidden="true">
            C
          </span>
          <span className="site-footer__name">Carely IT</span>
        </div>
        <p className="site-footer__tagline">
          One calm workspace for every branch, team member, and client
          conversation in your organization.
        </p>
      </div>

      <nav className="site-footer__nav" aria-label="Footer">
        <span className="site-footer__heading">Product</span>
        {FOOTER_LINKS.map((link) => (
          <Link key={link.to} to={link.to} className="site-footer__link">
            {link.label}
          </Link>
        ))}
      </nav>

      <div className="site-footer__contact">
        <span className="site-footer__heading">Contact</span>
        <a className="site-footer__phone" href="tel:01916707697">
          01916707697
        </a>
        <a className="site-footer__email" href="mailto:zonayed@carelyit.com">
          zonayed@carelyit.com
        </a>
        <span className="site-footer__social-note">
          Social links coming soon
        </span>
      </div>
    </div>

    <div className="site-footer__bottom">
      <span>© {new Date().getFullYear()} Carely IT. All rights reserved.</span>
    </div>
  </footer>
);

export default SiteFooter;
